import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../dist/jsx-render/dom";
import { DynPopup } from "../DynPopup";
import { app } from "../../Frame/App";
import { DropDownComponent, DropDownComponentProps } from "../DropDownComponent";
import { ITreeItem } from "../../Controls/Dynamic/ITreeItem";
import { MeasureImportTemplateField } from "./Models/MeasureImportTemplateField";

export class MMappingImportMeasure {
    templateId: number;
    isTemplateOnlyChild: boolean;
    templateAddOverwrite: number;
    parentCategoryId: number;
    templateColumns: MeasureImportTemplateField[];
    listImportedFileRows: ImportFileRow[];
    mappedResults: MappingItemResult[];
    tryImport: boolean;
    forceImport: boolean;
    resultImport: string;
    IsSuccess: boolean;
    public dataTemplateId: number;
}


export class ImportFileRow {
    rowIndex: number;
    Cells: Cell[];
}
export class Cell {
    cellIndex: number;
    cellValue: string;
}
export class MappingItemResult {
    isParentIdColumn: boolean;
    cellIndex: number;
    cellValue: string;
    selectedId: string;
    selectedValue: string;
    categoryId: string;
    parentCategoryId: string;
    parentCategoryName: string;
    isActive: boolean;
}
export class MappingModel {
    templateId: number;
    isTemplateOnlyChild: boolean = false;
    templateAddOverwrite: number;
    parentId: string;
    listTemplateFields: MeasureImportTemplateField[];
    listRowsImported: ImportFileRow[];
    listHeaderColumnsImported: Cell[];
    mappedResults: MappingItemResult[];
    resultImport: string;
    IsSuccess: boolean;
    public dataTemplateId: number;
}
export class MappingImportedMeasure extends JSXComponent {

    private element: HTMLElement;
    private urlResponse: string;
    private model: MappingModel;
    private wasAlreadyInMappingResult: boolean = false;
    private listRenderedDropdown: DropDownComponent[] = [];
    private ajaxurlproceedimport: string = '~/api/Admin/proceedImportMeasure/';

    constructor(resultUrl: string) {
        super();
        this.urlResponse = resultUrl;

    }

    show() {
        //check if we have already a mapping table or not
        if (this.model == null) {
            this.model = this.fromJson();
            this.model.mappedResults = [];
        }
        this.element = <DynPopup showSaveButton={true} labelSaveButton={Resources.Common.next} showCancelButton={true} onSave={this.onNextClick}
            title={Resources.Admin.importMeasuresMapFields}>
            <div id="mappingTemplateContainer">

            </div>
        </DynPopup>;
        document.body.appendChild(this.element);
        this.renderMappingTemplate();
    }

    showValidationMapping() {
        ////if is success: show only close button with result
        //delete old error div and replace it by new one
        //hide all buttons and leave only Abbrechen
        if (this.model.IsSuccess == true) {

            //test if the template result already exist else create new one
            if (document.querySelector('#mappingResultTemplateContainer') != null) {

                if (document.querySelector('#errorImportValidation') != null) {
                    document.querySelector('#errorImportValidation').remove();
                }
                if (document.querySelector('#proceedImportTitle') != null) {
                    document.querySelector('#proceedImportTitle').remove();
                }

                this.createErrorDivControl("resultImport", "mappingResultTemplateContainer", "success");

                if (document.querySelectorAll("[aria-label=" + Resources.Common.cancel + "]")[1] != null) {
                    document.querySelectorAll("[aria-label=" + Resources.Common.cancel + "]")[1].innerHTML = Resources.Common.close;
                }
                console.log(Resources.Common.yes);
                if (document.querySelectorAll("[aria-label=" + Resources.Common.yes + "]")[0] != null) {
                    document.querySelectorAll("[aria-label=" + Resources.Common.yes + "]")[0].remove();
                }
                if (document.querySelectorAll("[aria-label=" + Resources.Common.previous + "]")[0] != null) {
                    document.querySelectorAll("[aria-label=" + Resources.Common.previous + "]")[0].remove();
                }
            }
            else {
                //create new modal
                this.element = <DynPopup showCancelButton={true} onCancel={this.onCancel} title={"Mapping measures"}>
                    <div id="mappingResultTemplateContainer">

                    </div>
                </DynPopup>;

                //Display the result of import
                document.body.appendChild(this.element);
                this.createErrorDivControl("resultImport", "mappingResultTemplateContainer", "success");

                //Button Cancel should be renamed no
                var buttonCancel = document.querySelectorAll("[aria-label=" + Resources.Common.cancel + "]")[1];
                buttonCancel.innerHTML = Resources.Common.close;
            }
        }
        else {
            ////if no success
            ////show  yes no previous button with results
            this.element = <DynPopup showCancelButton={true} onCancel={this.onCancel} showOkButton={true} showSaveButton={true} showCloseButton={true} labelSaveButton={Resources.Common.yes} labelOkButton={Resources.Common.previous} onSave={this.onImport}
                title={"Mapping measures"}>
                <div id="mappingResultTemplateContainer">
                    <div className="form-group">
                        <p id="proceedImportTitle">{Resources.Common.reRunImportTitle}</p>
                    </div>
                </div>
            </DynPopup>;

            //Display the result of import
            document.body.appendChild(this.element);
            this.createErrorDivControl("resultImport", "mappingResultTemplateContainer", "error");

            //Button Cancel should be renamed no
            var buttonCancel = document.querySelectorAll("[aria-label=" + Resources.Common.cancel + "]")[1];
            buttonCancel.innerHTML = Resources.Common.no;
        }
        return false;
    }

    private onCancel = (event: Event) => {
        location.reload();
        return true;
    }

    private onImport = (event: Event) => {

        var dataModel = new MMappingImportMeasure();
        dataModel.templateId = this.model.templateId;
        dataModel.isTemplateOnlyChild = this.model.isTemplateOnlyChild;
        dataModel.templateAddOverwrite = this.model.templateAddOverwrite;
        dataModel.listImportedFileRows = this.model.listRowsImported;
        dataModel.mappedResults = this.model.mappedResults;
        dataModel.dataTemplateId = this.model.dataTemplateId;
        dataModel.tryImport = false;
        dataModel.forceImport = true;
        $.ajax({
            url: app.resolveUrl(this.ajaxurlproceedimport),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(dataModel),
            type: "POST",
            success: (response) => {
                this.urlResponse = response.message;
                //update the model from json
                this.updateModelFromResultImportJson();
                this.showValidationMapping();
            },
            error: (err) => {
                console.log("error: " + err);
                this.createErrorDivControl("" + err, "mappingResultTemplateContainer", "error");
            }
        });
        return false;
    }

    private onNextClick = (event: Event) => {


        let errorDiv = document.getElementById("errorImportValidation");
        if (typeof (errorDiv) != 'undefined' && errorDiv != null) {
            errorDiv.remove();
        }
        if (!this.CheckIfRequiredFieldsAremapped()) {
            //redirect to mapping reult
            this.wasAlreadyInMappingResult = true;

            var dataModel = new MMappingImportMeasure();
            dataModel.templateId = this.model.templateId;
            dataModel.dataTemplateId = this.model.dataTemplateId;
            dataModel.isTemplateOnlyChild = this.model.isTemplateOnlyChild;
            dataModel.templateAddOverwrite = this.model.templateAddOverwrite;
            dataModel.listImportedFileRows = this.model.listRowsImported;
            dataModel.mappedResults = this.model.mappedResults.sort((a, b) => (a.categoryId > b.categoryId) ? 1 : -1);
            dataModel.tryImport = true;
            dataModel.forceImport = false;
            dataModel.IsSuccess = false;
            this.model.IsSuccess = false;
            //ajax call for import
            $.ajax({
                url: app.resolveUrl(this.ajaxurlproceedimport),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(dataModel),
                type: "POST",
                success: (response) => {

                    this.urlResponse = response.message;
                    //update the model from json
                    this.updateModelFromResultImportJson();
                    this.showValidationMapping();
                },
                error: (err) => {
                    console.log("error: " + err);
                    this.createErrorDivControl("" + err, "mappingResultTemplateContainer", "error");

                }
            });
            return false;
        }
        else {
            return false;
        }
    }
    private updateModelFromResultImportJson() {
        var obj = JSON.parse(this.urlResponse);
        this.model.IsSuccess = obj.isSuccess;
        this.model.resultImport = obj.resultImport;
    }
    private CheckIfRequiredFieldsAremapped(): boolean {

        if (this.model.templateAddOverwrite == 1) {
            //check id measer is mapped
            if (this.CheckIfIdMeasureIsMapped() < 1) {
                this.createErrorDivControl("Measure id should be mapped", "mappingTemplateContainer", "error");
                return true;
            }
        }
        if (this.model.isTemplateOnlyChild == true) {
            if (this.CheckIsParentIdMapped() == false) {
                this.createErrorDivControl("Parent id is required!", "mappingTemplateContainer", "error");
                return true;
            }
        }
        return false;
    }
    //check for the mapping if the parent id is selected if the event is used in child mode
    private CheckIsParentIdMapped(): boolean {
        if (this.model.isTemplateOnlyChild) {
            var searchText = Resources.Common.measure + ": ParentId";
            for (let i = 0; i < this.model.mappedResults.length; i++) {
                if (this.model.mappedResults[i].selectedValue.split(/[: ]+/).pop().toLowerCase() == searchText.toLowerCase()) {
                    return true;
                }
            }
        }
        return false;
    }
    //check if id is mapped: id is required only if we have an overwrite operation
    private CheckIfIdMeasureIsMapped(): number {
        let count = 0;
        //Ressource.Common.ID doesn't work
        var searchText = Resources.Common.measure + ": ID";

        //check if id is mapped in mapping tabelle
        for (let i = 0; i < this.model.mappedResults.length; i++) {
            if (this.model.mappedResults[i].selectedValue.toLowerCase() == searchText.toLowerCase()) {
                count++;
            }
        }
        return count;
    }
    //convert the response url to model
    private fromJson(): MappingModel {
        var jsonObject = JSON.parse(this.urlResponse);
        var item = new MappingModel;
        var jsonMapp = jsonObject.message;

        var obj = JSON.parse(jsonMapp);

        if (obj.templateId) {
            item.templateId = obj.templateId;
        }

        if (obj.isTemplateIsOnlyChild) {
            item.isTemplateOnlyChild = obj.isTemplateIsOnlyChild;
        }

        item.dataTemplateId = obj.dataTemplateId;

        item.templateAddOverwrite = obj.templateAddOverwrite;


        if (obj.templateColumns) {
            item.listTemplateFields = obj.templateColumns.children;

        }

        if (obj.listImportedFileRows) {
            //get list of headerColumn
            item.listHeaderColumnsImported = obj.listImportedFileRows[0].cells;
            //get list of allRows
            item.listRowsImported = obj.listImportedFileRows;
        }

        return item;
    }
    //render mapping template
    private renderMappingTemplate() {
        //loop list of importedFields
        for (let i = 0; i < this.model.listHeaderColumnsImported.length; i++) {
            var id = this.model.listHeaderColumnsImported[i].cellIndex.toString();
            //todo check if the parent id is set or not
            var value = this.model.listHeaderColumnsImported[i].cellValue;
            //should like valueCell_Id
            let divValueId = value + "~-~" + this.model.listHeaderColumnsImported[i].cellIndex.toString();
            let erd: HTMLElement;

            erd = <div className="form-group mappinItem" >
                <div className="value" id={divValueId}>
                </div>
            </div>;
            document.getElementById('mappingTemplateContainer').append(erd);
            let elementis = this.createEventListControl(value, id);
            document.getElementById(divValueId).append(elementis);
        }
    }
    ////render event dropdown
    private createEventListControl = (labelName: string, labelId: string) => {

        let selectedValue: string;
        let isItemExistInMappTable = this.model.mappedResults.find(p => p.cellIndex == parseInt(labelId) && p.cellValue == labelName);
        if (isItemExistInMappTable != null && isItemExistInMappTable.selectedId > "-1") {
            selectedValue = this.model.mappedResults.find(p => p.cellIndex == parseInt(labelId) && p.cellValue == labelName).selectedId;
        }
        else {
            selectedValue = this.CheckIfNameExistListEvent(labelName, labelId);
        }
        //Hack AB : since we are giving the same list of items everytime we create a dropdown 
        //so we remove the empty items in this case only one empty item will be added at the time
        this.model.listTemplateFields = this.model.listTemplateFields.filter(function (el) {
            return el.text != "";
        });

        let dropdownProps = {
            displayProperty: "text",
            valueProperty: "id",
            addEmptyItem: true,
            childrenProperty: "children",
            name: labelName,
            id: labelId,
            allowSelect: true,
            items: this.model.listTemplateFields,
            disableSort: true,
            onChange: this.handleChange,
            selectedValue: selectedValue,
        }
        let dropdownReference = new DropDownComponent(dropdownProps);
        this.listRenderedDropdown.push(dropdownReference);
        return (dropdownReference).render();
    }
    ////append error div
    private createErrorDivControl(labelErrorName: string, containerId: string, typeContainer: string) {
        let aClassname: string;
        switch (typeContainer) {
            case "error":
                aClassname = "alert alert-danger";
                break;
            default:
                aClassname = "alert alert-info";
                break;
        }

        let errorMessage: HTMLDivElement = <div class={aClassname} id="errorImportValidation" role="alert" >
        </div>;

        if (labelErrorName == "resultImport") {
            ////todo render the error  split and display in lines
            let result: string[] = this.model.resultImport.split('\r\n');
            for (let i = 0; i < result.length; i++) {
                if (result[i] || result[i].trim() !== '') {
                    let p: HTMLParagraphElement = <p>{result[i]}</p>;
                    errorMessage.appendChild(p);
                }
            }
        }
        else {
            let p: HTMLParagraphElement = <p>{labelErrorName}</p>;
            errorMessage.insertBefore(p, errorMessage.lastChild);
        }
        let container = document.getElementById(containerId);
        if (container) {
            container.insertBefore(errorMessage, container.firstChild);
        }
    }

    private handleChange = (control: DropDownComponent) => {

        //remove div error if exist
        if (document.getElementById("errorImportValidation")) {
            document.getElementById("errorImportValidation").remove();
        }

        //get the old values from table mapping
        let arrayColumnItem = control.element.parentElement.id.split("~-~");
        let mappingCellIndex = arrayColumnItem[1];
        let mappingOldResult = this.model.mappedResults.find(p => p.cellIndex == parseInt(mappingCellIndex));
        //if there is a maaping
        if (mappingOldResult) {
            this.model.mappedResults = this.model.mappedResults.filter(p => p.cellIndex != mappingOldResult.cellIndex);
        }

        let selectedItem = control.getSelectedItem();
        if (selectedItem.text == "") {
            if (mappingOldResult) {
                if (this.listRenderedDropdown[mappingOldResult.cellIndex]) {

                    if (this.listRenderedDropdown[mappingOldResult.cellIndex].inputName) {
                        this.listRenderedDropdown[mappingOldResult.cellIndex].inputName.value = "";
                    }
                    if (this.listRenderedDropdown[mappingOldResult.cellIndex].inputValue) {
                        this.listRenderedDropdown[mappingOldResult.cellIndex].inputValue.value = "";
                    }
                }
            }
        }
        else {
            let item = new MappingItemResult();
            item.isParentIdColumn = false;
            item.cellIndex = parseInt(mappingCellIndex);
            item.cellValue = arrayColumnItem[0];
            item.selectedId = selectedItem.id;
            item.selectedValue = selectedItem.text;
            item.categoryId = selectedItem.categoryId;
            item.parentCategoryName = selectedItem.parentCategoryName;
            item.parentCategoryId = selectedItem.parentCategoryId;
            this.model.mappedResults.push(item);
            console.log(this.model.mappedResults);
        }
    }
    //check if the name of imported cell if exist in the list of event return the index to be set as selected value in the dropdown
    //updated:  if  result >-1 will insert the maaping item in the list of mapping
    private CheckIfNameExistListEvent(name: string, id: string): string {
        let indexItem = this.model.mappedResults.findIndex(p => p.cellValue.toLowerCase() == name.toLowerCase());

        // on previous button click it should not mapp automatically the fields that wasn't mapped before
        if (this.wasAlreadyInMappingResult && indexItem <= -1) {
            return "0";
        }

        let listSelectedItems = this.model.listTemplateFields.filter(p => p.fieldName == name);
        if (!listSelectedItems || !listSelectedItems.length) {
            // Allow to match excel columns like 'Status: Bewertung und Zuordnung: erledigt durch'
            listSelectedItems = this.model.listTemplateFields.filter(p => p.text == name);
        }

        for (let i = 0; i < listSelectedItems.length; i++) {
            if (name.toLocaleLowerCase() == listSelectedItems[i].fieldName.toLowerCase()
                || name.toLocaleLowerCase() == listSelectedItems[i].text.toLowerCase()) {

                //if the event is already mapped or selected by another event we delete  it
                //should be contains
                let EventFieldIsmapped = this.model.mappedResults.findIndex(p => p.cellValue == name.toLocaleLowerCase());
                if (EventFieldIsmapped > -1) {
                    this.model.mappedResults.splice(EventFieldIsmapped, 1);
                }
                let item = new MappingItemResult();
                item.isParentIdColumn = false;
                item.cellIndex = parseInt(id);
                item.cellValue = name;
                item.selectedId = listSelectedItems[i].id;
                item.selectedValue = listSelectedItems[i].text;
                item.categoryId = listSelectedItems[i].categoryId;
                item.parentCategoryName = listSelectedItems[i].parentCategoryName;
                item.parentCategoryId = listSelectedItems[i].parentCategoryId;
                this.model.mappedResults.push(item);
                return listSelectedItems[i].id;
            }
        }
        ////0 is the value id of the empty field
        return "0";
    }

}

